import React from "react";
import { Cookie, Cake, Heart, Star, IceCream, Candy, Sparkles } from "lucide-react";

// Subtle floating bakery decorations for backgrounds
export const FloatingDecor = () => {
  const items = [
    { Icon: Cookie, top: "12%", left: "6%", size: 34, delay: "0s", op: 0.12 },
    { Icon: Cake, top: "68%", left: "4%", size: 40, delay: "1.2s", op: 0.1 },
    { Icon: Heart, top: "22%", left: "88%", size: 28, delay: "0.6s", op: 0.14 },
    { Icon: Star, top: "78%", left: "90%", size: 30, delay: "1.8s", op: 0.1 },
    { Icon: Candy, top: "44%", left: "94%", size: 26, delay: "2.4s", op: 0.1 },
    { Icon: IceCream, top: "8%", left: "50%", size: 26, delay: "3s", op: 0.08 },
  ];
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden -z-0" aria-hidden>
      {items.map(({ Icon, top, left, size, delay, op }, i) => (
        <Icon key={i} className="absolute animate-floaty text-vino" strokeWidth={1.5}
          style={{ top, left, width: size, height: size, opacity: op, animationDelay: delay }} />
      ))}
    </div>
  );
};

export const SectionTitle = ({ children, sub }) => (
  <div className="text-center mb-8">
    <h2 className="font-serif text-3xl sm:text-4xl text-vino tracking-tight flex items-center justify-center gap-2">
      <Sparkles className="w-5 h-5 text-dorado" /> {children}
    </h2>
    {sub && <p className="mt-2 text-cafe/70 text-sm sm:text-base max-w-xl mx-auto">{sub}</p>}
  </div>
);
